import { render, staticRenderFns } from "./EditWidgetCommentsDialog.vue?vue&type=template&id=93fbfa70&scoped=true"
import script from "./EditWidgetCommentsDialog.vue?vue&type=script&lang=js"
export * from "./EditWidgetCommentsDialog.vue?vue&type=script&lang=js"
import style0 from "./EditWidgetCommentsDialog.vue?vue&type=style&index=0&id=93fbfa70&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93fbfa70",
  null
  
)

export default component.exports